import { t } from '@lingui/core/macro';
import { Box, IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useFileBrowserContext } from 'app/domains/filesystem';
export function SelectedEntry(props) {
    const { entry } = props;
    const { selectable, onSelect, selectFolder } = useFileBrowserContext();
    const canBeDeselected = selectable && selectable(entry);
    const handleDeselect = () => {
        onSelect(entry);
    };
    const handleNavigate = () => {
        if (entry.parentId) {
            selectFolder(entry.parentId);
        }
    };
    return (<Menu.Item onClick={handleNavigate}>
      {entry.name}
      {canBeDeselected && (<Box ml="auto">
          <IconButton size="xs" aria-label={t({
                message: 'Remove',
                comment: 'File browser: Deselect button',
                context: 'entry-picker',
            })} appearance="ghost" disabled={selectable && !selectable(entry)} onClick={handleDeselect}>
            <Falcon icon="xmark"/>
          </IconButton>
        </Box>)}
    </Menu.Item>);
}
